'use client'

// src/auth-service.tsx
var createAuthService = (clerk) => {
  if (!(clerk == null ? void 0 : clerk.client)) {
    throw new Error("Clerk client not available.");
  }
  const client = clerk.client;
  let authCallback;
  const onLogin = async (params, options) => {
    if (params.provider) {
      await client.signIn.authenticateWithRedirect({
        strategy: `oauth_${params.provider}`,
        redirectUrl: "/#sso_callback",
        redirectUrlComplete: (options == null ? void 0 : options.redirectTo) || "/"
      });
      return;
    }
    let clerkParams;
    if (!params.email) {
      return;
    } else if (params.password) {
      clerkParams = {
        identifier: params.email,
        password: params.password
      };
    } else {
      clerkParams = {
        identifier: params.email
      };
    }
    const signIn = await client.signIn.create(clerkParams);
    if (signIn.status === "complete" && signIn.createdSessionId) {
      await clerk.setActive({
        session: signIn.createdSessionId
      });
      return onLoadUser();
    }
    const { emailAddressId } = signIn.supportedFirstFactors.find(
      (ff) => ff.strategy === "email_link" && ff.safeIdentifier === params.email
    );
    const { startMagicLinkFlow } = client.signIn.createMagicLinkFlow();
    startMagicLinkFlow({
      emailAddressId,
      redirectUrl: window.location.href + "/#ml_callback"
    }).then(async (result) => {
      if (result.status === "complete") {
        await clerk.setActive({
          session: result.createdSessionId
        });
        authCallback == null ? void 0 : authCallback(await onLoadUser());
      }
    });
  };
  const onAuthStateChange = (callback) => {
    authCallback = callback;
    return () => authCallback = null;
  };
  const onSignup = async (params, options) => {
    try {
      const clerkParams = {};
      if (params.email) {
        clerkParams.emailAddress = params.email;
      }
      if (params.password) {
        clerkParams.password = params.password;
      }
      const signUpAttempt = await client.signUp.create(clerkParams);
      const result = await signUpAttempt.prepareEmailAddressVerification({
        strategy: "email_link",
        redirectUrl: (options == null ? void 0 : options.redirectTo) || window.location.href
      });
      return result;
    } catch (e) {
      console.error(e);
      throw e;
    }
  };
  const onLogout = async () => {
    return await clerk.signOut();
  };
  const onLoadUser = async () => {
    var _a;
    return clerk.user ? {
      email: (_a = clerk.user.primaryEmailAddress) == null ? void 0 : _a.emailAddress,
      ...clerk.user
    } : null;
  };
  const onGetToken = async () => {
    var _a;
    return ((_a = clerk.session) == null ? void 0 : _a.id) || null;
  };
  return {
    onLogin,
    onAuthStateChange,
    onSignup,
    onLogout,
    onLoadUser,
    onGetToken
  };
};

// src/clerk-auth-provider.tsx
import {
  ClerkProvider,
  WithClerk,
  AuthenticateWithRedirectCallback
} from "@clerk/clerk-react";
import { jsx, jsxs } from "react/jsx-runtime";
var ClerkAuthProvider = (props) => {
  const {
    children,
    frontendApi,
    publishableKey,
    proxyUrl,
    domain,
    isSatellite,
    clerkJSUrl,
    ...rest
  } = props;
  const isSSOCallback = typeof window !== "undefined" && window.location.hash === "#sso_callback";
  return (
    /* @ts-expect-error */
    /* @__PURE__ */ jsxs(
      ClerkProvider,
      {
        frontendApi,
        publishableKey,
        clerkJSUrl,
        proxyUrl,
        domain,
        isSatellite,
        ...rest,
        children: [
          isSSOCallback && /* @__PURE__ */ jsx(AuthenticateWithRedirectCallback, {}),
          /* @__PURE__ */ jsx(WithClerk, { children: (clerk) => {
            return children({ authService: createAuthService(clerk), clerk });
          } })
        ]
      }
    )
  );
};
export {
  ClerkAuthProvider,
  createAuthService
};
//# sourceMappingURL=index.mjs.map